import actionTypes from '../actionTypes';

export const getUserWorks = (userId) => ({
  type: actionTypes.USER_WORKS_GET_REQUEST,
  userId,
});

export const getWork = (workId) => ({
  type: actionTypes.WORK_GET_REQUEST,
  workId,
});

export const selectWork = (work) => ({
  type: actionTypes.WORK_SELECT,
  work,
});

export const createWork = (work) => ({
  type: actionTypes.WORK_CREATE_REQUEST,
  work,
});

export const updateWork = (workId, work) => ({
  type: actionTypes.WORK_UPDATE_REQUEST,
  workId,
  work,
});

export const deleteWork = (workId) => ({
  type: actionTypes.WORK_DELETE_REQUEST,
  workId,
});



// WEBPACK FOOTER //
// src/redux/actions/works.js